module.exports = __webpack_public_path__ + "img/link.ae321b77.png";